import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import { Form, input } from "antd";
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import 'react-datetime/css/react-datetime.css';

const {TextArea} = input;

class RegionPharmacyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false,
            isLoading: false,
            fieldsDisabled: false,
            mode: this.props.mode,
            selectedUsers:null,
            selectedGroups:null,
            notes: {},
            selectedRegionPharmacies: []

        };

        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.listEczaneler = this.listEczaneler.bind(this);

    }
    componentDidMount() {
        this.listEczaneler()
    }

    listEczaneler() {
        let self = this;
        let regionId = self.props.selectedRegion.id
        let params = {
            url: API_BASE_URL+"/regions/" + regionId + "/pharmacies" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let selectedRegionPharmacies = response.data;
                console.log("eczaneler", response.data)
                self.setState({
                    selectedRegionPharmacies,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        console.log("this.props.selectedRegionPharmaciesegion", this.state.selectedRegionPharmaciesegion)
        let selectedRegionPharmacies = this.state.selectedRegionPharmacies
        console.log("this.props.selectedRegionPharmacies", this.state.selectedRegionPharmacies)
        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                        <Form>
                            <div className="mt-2">
                                <span className="form-title"
                                      style={{left: "30px", marginTop: "-20px"}}>Eczane Bilgileri</span>
                                {selectedRegionPharmacies && selectedRegionPharmacies.length > 0 ?
                                selectedRegionPharmacies.map((phamacy) => (
                                    <div className="FormRenk col-sm-12">
                                        <div className='row'>
                                            <label className="col-sm-4">{phamacy.name} </label>
                                            <div className="col-sm-8 form-group">
                                                <label>{phamacy.location}</label> <br/>
                                                <label>Tel No: {phamacy.phone}</label> <br/>
                                                <label>{phamacy.region.regionName}</label>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                    "Eczane Bulunamadı."
                                }
                            </div>
                        </Form>
                    <div className="save-button-container">
                        <button onClick={this.cancelProcess}
                                className="member-save-button"
                                disabled={this.state.isLoading}
                        >
                            TAMAM
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default RegionPharmacyModal;;



// WEBPACK FOOTER //
// ./src/page/regions/RegionPharmacyModal.js